import { FormattedText, ParaTag, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";

import type { TextNodeType } from "../../../../components/FormattedText/FormattedText";
import {
  OrderDataTableGrid,
  OrderDataTableItem,
  StackedTableItem,
  StackedTableList,
} from "./OrderDataTable.style";

export type OrderDataTableVariant = "grid" | "stacked";

export interface OrderDataTableProps {
  orderDetails?: {
    label?: string | TextNodeType;
    value?: string | TextNodeType;
  }[];
  variant?: OrderDataTableVariant;
}

export const OrderDataTable: React.FC<OrderDataTableProps> = ({
  orderDetails,
  variant = "grid",
}) => {
  if (variant === "stacked") {
    return (
      <StackedTableList>
        {orderDetails?.map((item, index) => (
          <StackedTableItem key={index}>
            {item.label && (
              <SpanTag fontSize="sm" fontWeight="black">
                <FormattedText value={item.label} />
              </SpanTag>
            )}
            <SpanTag fontSize="sm">
              <FormattedText value={item.value} />
            </SpanTag>
          </StackedTableItem>
        ))}
      </StackedTableList>
    );
  }

  return (
    <OrderDataTableGrid>
      {orderDetails?.map((item, index) => (
        <OrderDataTableItem gap="16px" key={index}>
          {item.label && (
            <ParaTag
              textTransform="uppercase"
              color={theme.greyText7}
              fontSize="xs"
            >
              <FormattedText value={item.label} />
            </ParaTag>
          )}
          <SpanTag
            fontSize="xs"
            fontWeight="bold"
            style={{ textAlign: "left" }}
          >
            <FormattedText value={item.value} />
          </SpanTag>
        </OrderDataTableItem>
      ))}
    </OrderDataTableGrid>
  );
};
